import { render } from "./NewBoard.vue?vue&type=template&id=fef033d4&scoped=true"
import script from "./NewBoard.vue?vue&type=script&lang=js"
export * from "./NewBoard.vue?vue&type=script&lang=js"

import "./NewBoard.vue?vue&type=style&index=0&id=fef033d4&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef033d4"]])

export default __exports__